import { Component } from '@angular/core';
import { Mode, NumberFieldComponent } from './number-field.component';

@Component( {
    selector: 'erp-pbw-teilzeitumfang',
    templateUrl: './number-field.component.html'
} )
export class PartTimeScopeValueComponent extends NumberFieldComponent {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.partTimeScope',
            { min: 0, max: 100, minFractionDigits: 0, maxFractionDigits: 0, suffix: ' %' }
        );
    }

    set value( t: number | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.partTimeScope = t;
        }
    }

    get value(): number | undefined {
        return this.jobapplication?.partTimeScope;
    }
}
